import bem from '../../../utils/bem';

export interface NotificationLogTitleProps {
  id: string;
  formattedDate: string;
}
const [block, element] = bem('notification-log-title');

const NotificationLogTitle = ({ id = '', formattedDate }: NotificationLogTitleProps): JSX.Element => (
  <div key={id} className={block()} data-testid="notification-log-title">
    <span className={element('bold-title')}>{formattedDate}</span>
  </div>
);

export default NotificationLogTitle;
